var Marker = require('../../lib/markers/marker.js');
var Deletism = require('../../lib/markers/deletism.js');
var Undeletism = require('../../lib/markers/undeletism.js');
var Copier = require('../../lib/markers/copier.js');

export default function () {
  var marker = new Marker();

  new Deletism(marker);
  new Undeletism(marker);
  new Copier(marker);
};
